import { render, staticRenderFns } from "./ConnectionPopover.vue?vue&type=template&id=33083cea&scoped=true&"
import script from "./ConnectionPopover.vue?vue&type=script&lang=js&"
export * from "./ConnectionPopover.vue?vue&type=script&lang=js&"
import style0 from "./ConnectionPopover.vue?vue&type=style&index=0&id=33083cea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33083cea",
  null
  
)

export default component.exports